import { useTagsStore } from '@/store/tags'

export default function (to, from, next) {
  const tagsStore = useTagsStore()
  if (to.path === '/login') {
    tagsStore.clearVisitedTags()
    tagsStore.clearCachedTags()
  }
  if (to.path.startsWith('/link/operate')) {
    if (to.params.id) {
      to.meta.title = `${to.query.c === '1' ? '拷贝_' : '编辑_'}${to.query.name || ''}`
    } else {
      to.meta.title = '新建链接'
    }
  }
  if (to.path.startsWith('/cRecord')) {
    to.meta.title = `点击记录_${to.query.title || ''}`
  }
  if (to.path.startsWith('/cRecord/statistic')) {
    to.meta.title = `访问统计_${to.query.title || ''}`
  }
  if (to.meta.keepAlive) {
    tagsStore.addVisitedTags(to)
    tagsStore.addCachedTags(to)
  }
  next()
}